import React, { useState, useEffect } from "react";
import style from "../../../css/Product.module.css";
import Cookies from "js-cookie";
import { useSearchParams } from "react-router-dom";
import useLanguage from "../../../Hooks/useLanguage";
import { useTranslation } from 'react-i18next';
const PackagesCSHP = ({ serverchose, onSelectedPackage, selectedChildSystem, cookieData }) => {

    const [plans, setPlans] = useState([]);
    const [selectedTab, setSelectedTab] = useState("Basic");
    const [selectedPackageId, setSelectedPackageId] = useState(null);
    const [filteredPackages, setFilteredPackages] = useState([]);
    const [minCore, setMinCore] = useState(0);
    const [minMemory, setMinMemory] = useState(0);
    const [minStorage, setMinStorage] = useState(0);

    const [searchParams, setSearchParams] = useSearchParams();

    const [images, setImages] = useState([]); // Lưu trữ danh sách images
    useLanguage();

    const { t } = useTranslation();

    const url = process.env.REACT_APP_API_URL;

    useEffect(() => {
        if (serverchose?.categories) {
            const filteredPlans = serverchose.categories.filter(
                (category) => category.type === "plan"
            );
            setPlans(filteredPlans);

            if (filteredPlans.length > 0 && !selectedTab) {
                setSelectedTab(filteredPlans[0].name);
            }
        }
    }, [serverchose]);
    // console.log("selectedChildSystem", selectedChildSystem)
    useEffect(() => {
        const fetchImages = async () => {
            try {
                const response = await fetch(`${url}/api/v1/images/${selectedChildSystem}`);
                const data = await response.json();
                if (response.ok) {
                    setImages(data[0]);
                    setMinCore(data[0].min_core);
                    setMinMemory(data[0].min_memory);
                    setMinStorage(data[0].min_storage);
                }
            } catch (err) {
            } finally {
            }
        };

        if (selectedChildSystem) {
            fetchImages();
        }
    }, [selectedChildSystem]);


    useEffect(() => {
        if (plans.length > 0) {
            const tabFromUrl = searchParams.get("tab");
            const packageFromUrl = cookieData.package;

            const matchedPackage = plans.flatMap(plan => plan.packages || []).find(pkg => pkg.id === parseInt(packageFromUrl));
            let matchedTab;

            if (matchedPackage) {
                const relatedPlan = plans.find(plan =>
                    plan.packages.some(pkg => pkg.id === matchedPackage.id)
                );
                matchedTab = relatedPlan ? relatedPlan.name : plans[0].name;
                setSelectedPackageId(matchedPackage.id);
                onSelectedPackage(matchedPackage);
            } else {
                matchedTab = plans.find(plan => plan.name === tabFromUrl)?.name || plans[0].name;

                const defaultPackage = plans
                    .find(plan => plan.name === matchedTab)
                    ?.packages.slice(-1)[0];

                if (defaultPackage) {
                    setSelectedPackageId(defaultPackage.id);
                    onSelectedPackage(defaultPackage);
                }
            }

            setSelectedTab(matchedTab);
        }
    }, [plans, cookieData.package]);
    useEffect(() => {
        const selectedPackageType = plans.find(plan => plan.name === selectedTab);

        const validPackages = (selectedPackageType ? selectedPackageType.packages : []).filter(pkg =>
            pkg.core >= minCore &&
            pkg.memory >= minMemory &&
            pkg.storage >= minStorage
        );

        setFilteredPackages(validPackages);
    }, [selectedTab, plans, minCore, minMemory, minStorage]);


    // const handleTabSelect = (tabName) => {
    //     setSelectedTab(tabName);

    //     const defaultPackage = plans
    //         .find(plan => plan.name === tabName)
    //         ?.packages.slice(-1)[0];

    //     if (defaultPackage) {
    //         setSelectedPackageId(defaultPackage.id);
    //         onSelectedPackage(defaultPackage);
    //         setSearchParams({ tab: tabName, package: defaultPackage.id });
    //     } else {
    //         setSearchParams({ tab: tabName });
    //     }
    // };

    const handleTabSelect = (tabName) => {
        setSelectedTab(tabName);

        const defaultPackage = plans
            .find(plan => plan.name === tabName)
            ?.packages.slice(-1)[0];

        if (defaultPackage) {
            setSelectedPackageId(defaultPackage.id);
            onSelectedPackage(defaultPackage);

            const newSearchParams = new URLSearchParams(searchParams);
            newSearchParams.set("tab", tabName);
            newSearchParams.set("package", defaultPackage.id);

            setSearchParams(newSearchParams);
        } else {
            const newSearchParams = new URLSearchParams(searchParams);
            newSearchParams.set("tab", tabName);
            setSearchParams(newSearchParams);
        }
    };
    const handlePackageSelect = (pkg) => {
        setSelectedPackageId(pkg.id);
        onSelectedPackage(pkg);
        const relatedPlan = plans.find(plan => plan.packages.some(item => item.id === pkg.id));
        if (relatedPlan) {
            setSelectedTab(relatedPlan.name);
            setSearchParams({ tab: relatedPlan.name, package: pkg.id });
        } else {
            setSearchParams({ package: pkg.id });
        }
        // Cookies.set("Package", pkg.id, { expires: 7 });
    };


    const renderPackageTabs = () => (
        <div className="sv-type-list mb-2">
            <ul className="nav nav-tabs">
                {plans.map((type) => (
                    <li key={type.id} className="nav-item">
                        <button
                            className={`nav-link ${selectedTab === type.name ? "active" : ""}`}
                            onClick={() => handleTabSelect(type.name)}
                        >
                            {t(type.name)}
                        </button>
                    </li>
                ))}
            </ul>
        </div>
    );

    const renderTable = () => {
        if (plans.length === 0) {
            return <p>Không có kế hoạch nào để hiển thị.</p>;
        }

        return (
            <div className="table-responsive">
                <table className="table table-hover table-striped">
                    <thead style={{ backgroundColor: "#007bff", color: "white" }}>
                        <tr>
                            <td style={{ fontSize: "15px", fontWeight: "bold", textAlign: "left", padding: "10px" }}>{t("Name")}</td>
                            <td style={{ fontSize: "15px", fontWeight: "bold", textAlign: "center", padding: "10px" }}>{t("vCore")}</td>
                            <td style={{ fontSize: "15px", fontWeight: "bold", textAlign: "center", padding: "10px" }}>{t("Memory")}</td>
                            <td style={{ fontSize: "15px", fontWeight: "bold", textAlign: "center", padding: "10px" }}>{t("Storage")}</td>
                            <td style={{ fontSize: "15px", fontWeight: "bold", textAlign: "center", padding: "10px" }}>{t("Price")}</td>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredPackages.map((pkg) => (
                            <tr
                                key={pkg.id}
                                onClick={() => handlePackageSelect(pkg)}
                                style={{
                                    backgroundColor: selectedPackageId === pkg.id ? "#e9f7fd" : "#fff",
                                    border: selectedPackageId === pkg.id ? "2px solid #007bff" : "1px solid #e9ecef",
                                    borderRadius: "10px",
                                    cursor: "pointer",
                                    position: "relative"
                                }}
                            >
                                <td style={{ fontSize: "14px", padding: "12px", textAlign: "left", position: "relative" }}>
                                    {pkg.name}
                                </td>
                                <td style={{ fontSize: "14px", padding: "12px", textAlign: "center" }}>{pkg.core}</td>
                                <td style={{ fontSize: "14px", padding: "12px", textAlign: "center" }}>{pkg.memory}</td>
                                <td style={{ fontSize: "14px", padding: "12px", textAlign: "center" }}>{pkg.storage}</td>
                                <td style={{ fontSize: "14px", padding: "12px", textAlign: "center", position: "relative" }}>
                                    {pkg.cshp_price ? pkg.cshp_price.toLocaleString("vi-VN") : "N/A"}

                                    {selectedPackageId === pkg.id && (
                                        <>
                                            <span
                                                style={{
                                                    position: "absolute",
                                                    top: "0",
                                                    right: "0",
                                                    width: "0",
                                                    height: "0",
                                                    borderStyle: "solid",
                                                    borderWidth: "25px 0 0 25px",
                                                    borderColor: "#007bff transparent transparent transparent",
                                                }}
                                            ></span>

                                            <span
                                                style={{
                                                    position: "absolute",
                                                    top: "1px",
                                                    right: "1px",
                                                    color: "white",
                                                    fontSize: "12px",
                                                    // fontWeight: "bold",
                                                }}
                                            >
                                                ✔
                                            </span>
                                        </>
                                    )}
                                </td>
                            </tr>


                        ))}
                    </tbody>
                </table>

            </div>
        );
    };

    return (
        <div style={{ margin: 0, padding: 0 }} className="container">
            {renderPackageTabs()}
            {renderTable()}
        </div>
    );
};

export default PackagesCSHP;
